"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteImage = deleteImage;
exports.saveData = saveData;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _awsSdk = _interopRequireDefault(require("aws-sdk"));

var _uuid = require("uuid");

var _axios = _interopRequireDefault(require("axios"));

var S3_BUCKET = process.env.REACT_APP_IMAGES_BUCKET;
var REGION = "us-east-1";

_awsSdk.default.config.update({
  accessKeyId: process.env.REACT_APP_KUTS3,
  secretAccessKey: process.env.REACT_APP_AKUTS3
});

var myBucket = new _awsSdk.default.S3({
  params: {
    Bucket: S3_BUCKET
  },
  region: REGION
});

function saveData(_x) {
  return _saveData.apply(this, arguments);
}

function _saveData() {
  _saveData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(params) {
    var section, data, token;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            section = params.section, data = params.data, token = params.token;

            if (!(section === "images")) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return saveImagesData(data, token);

          case 4:
            if (!_context.sent) {
              _context.next = 5;
              break;
            }

          case 5:
            return _context.abrupt("return", true);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _saveData.apply(this, arguments);
}

function saveImagesData(_x2, _x3) {
  return _saveImagesData.apply(this, arguments);
}

function _saveImagesData() {
  _saveImagesData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(articles, token) {
    var imagesToUpdate, promiseArray, res;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            imagesToUpdate = [];
            articles.data.forEach(function (article) {
              var images = article.images,
                  version = article.version;
              console.log(images);
              var imagesToAdd = Object.values(images).filter(function (f) {
                return f.value && !f.value.src.startsWith("id-");
              });

              if (imagesToAdd.length > 0) {
                imagesToUpdate.push.apply(imagesToUpdate, (0, _toConsumableArray2.default)(imagesToAdd.map(function (e) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({
                    imageId: e.imageId
                  }, e.value), {}, {
                    version: version,
                    uuid: (0, _uuid.v4)()
                  });
                })));
              }
            });
            promiseArray = imagesToUpdate.map(function (e) {
              var src = e.src,
                  articleId = e.articleId,
                  imageId = e.imageId,
                  uuid = e.uuid,
                  ext = e.ext,
                  version = e.version;
              var file = Buffer.from(src.replace(/^data:image\/\w+;base64,/, ""), "base64");
              var params = {
                ACL: "public-read",
                Body: file,
                Bucket: S3_BUCKET,
                Key: "id-".concat(articleId, "/").concat(version, "/").concat(imageId, "-").concat(uuid, ".").concat(ext)
              };
              return myBucket.putObject(params).promise();
            });
            _context2.next = 5;
            return Promise.all(promiseArray);

          case 5:
            console.log("finish upload");
            _context2.next = 8;
            return _axios.default.put(process.env.REACT_APP_BASE_UPDATE_IMAGES_ENDPOINT, imagesToUpdate.map(function (e) {
              delete e.src;
              return e;
            }), {
              headers: {
                Authorization: token
              }
            });

          case 8:
            res = _context2.sent;

            if (!(res.data.statusCode !== 200)) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", false);

          case 11:
            return _context2.abrupt("return", true);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _saveImagesData.apply(this, arguments);
}

function deleteImage(_x4, _x5, _x6) {
  return _deleteImage.apply(this, arguments);
}

function _deleteImage() {
  _deleteImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(data, version, token) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.put("".concat(process.env.REACT_APP_ARTICLE_DATA_ENDPOINT, "?image=true&version=").concat(version), data, {
              headers: {
                Authorization: token
              }
            });

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _deleteImage.apply(this, arguments);
}